"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE = exports.KIND = exports.COLOR = void 0;
var _constants = require("./constants");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var KIND = exports.KIND = Object.keys(_constants.KIND_STYLES).reduce(function (kinds, currentKind) {
  return _objectSpread(_objectSpread({}, kinds), {}, _defineProperty({}, currentKind, currentKind));
}, {});

// TODO: Kept to avoid breaking changes
var COLOR = exports.COLOR = Object.keys(_constants.COLOR_STYLES).reduce(function (colors, currentColor) {
  return _objectSpread(_objectSpread({}, colors), {}, _defineProperty({}, currentColor, currentColor));
}, {});
var SIZE = exports.SIZE = Object.keys(_constants.SIZE_STYLES).reduce(function (sizes, currentSize) {
  return _objectSpread(_objectSpread({}, sizes), {}, _defineProperty({}, currentSize, currentSize));
}, {});